.nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  min-width: 0;
  overflow: hidden;
}

.link {
  display: flex;
  align-items: center;
  margin-right: 8px;
  font-weight: 300;
  text-decoration: none;
  cursor: pointer;
  color: inherit;
  font-size: var(--tuna-typography-fontSize-md);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
}

.inactiveLink {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.homeLink {
  display: flex;
  align-items: center;
  margin-right: 0;
  font-weight: 300;
  text-decoration: none;
  cursor: pointer;
  /* An active link: the disabled colour was 1.88:1 */
  color: var(--tuna-content-secondary);
}

.separator {
  color: var(--tuna-palette-text-secondary);
  margin: 0 4px;
}

.iconWrapper {
  margin-right: 4px;
}

.ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  padding: 0 2px;
  border: 0;
  border-radius: var(--tuna-shape-radius-sm);
  background: none;
  cursor: pointer;
  font: inherit;
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-fontSize-md);
}

/* Inset ring: the breadcrumb bar clips overflow, so an outset ring would be cut off */
.ellipsis:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

/* Menu mode: one path button; flex-shrink 0 so it never collapses below its hit area */
.pathButton {
  flex-shrink: 0;
}

/* Inset ring for the same reason as .ellipsis: the header clips overflow */
.pathButton:focus-visible {
  outline-offset: -2px;
}

.pathItem {
  display: flex;
  align-items: center;
}

.ellipsis:hover {
  color: var(--tuna-palette-text-primary);
}
